<template lang="pug">
.modal-visualizacao-reprovacao
    .linha(style='marginBottom: 0')
        b.coluna {{ "Justificativa:" }}
    .linha(style='margin: 0')
        .coluna {{ item.justificativa }}
    .linha
    .linha(style='margin: 5px 0')
        .coluna
            span.bold {{ "Retificação da proposta: " }}
            span.bold(v-if='item.retificacaoSolicitada', class='green') Sim
            span.bold(v-else, class='red') Não
    .linha(style='margin: 5px 0')
        .coluna
            span.bold {{ "Retificação do cadastro do imóvel: " }}
            span.bold(v-if='item.retificacaoImovel', class='green') Sim
            span.bold(v-else, class='red') Não
    .linha(style='margin: 5px 0')
        .coluna
            span.bold {{ "Documentos solicitados: " }}
            span.bold(v-if='item.documentos?.length > 0', class='green') Sim
            span.bold(v-else, class='red') Não
    .linha(v-if="item.documentos?.length", style='margin: 0 0 10px 0')
        .coluna
            ul(style='margin: 0')
                li(v-for='(doc, i) in item.documentos')
                    span {{ doc.nome }} - {{ doc.descricao }}

</template>

<script>
export default {

    name: 'VisualizacaoValidacaoModal',

    props: {
        item: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
        };
    }
};
</script>

<style lang="scss">
.green {
  color: #008000;
}

.red {
  color: #ff0000;
}
</style>
